import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  NgForm,
  Validators,
} from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../services/user.service';
import { TokenStorageService } from '../../services/storage/token-storage.service';
import { Router } from '@angular/router';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';

import { AddInstitutionMainComponent } from '../add-institution-main/add-institution-main.component';
import { SessionService } from '../../services/session/session.service';

@Component({
    selector: 'app-add-institution',
    templateUrl: './add-institution.component.html',
    styleUrls: ['./add-institution.component.css'],
    standalone: false
})
export class AddInstitutionComponent implements OnInit {
  addInstitutionSubmitted: boolean = false;
  instForm: FormGroup = new FormGroup({});
  isSuccessful: boolean = false;
  isSignUpFailed: boolean = true;
  errorMessage: string = '';
  loading: boolean = false;
  initialLoading: boolean = false;
  isLoggedIn: boolean = false;
  role: string = '';
  user: any;
  institutions: any;
  isFormValid: boolean = false;
  banks: any;
  instCode: any;
  readOnlyValue: boolean = false;

  @Output() apiEvent = new EventEmitter<object>();
  @Output() btnClicked = new EventEmitter<void>();
   @ViewChild(AddInstitutionMainComponent) AddInstitution!: AddInstitutionMainComponent;
  showPasswordStrength: boolean = false;
  newPasswordType: boolean = false;
  con: any;
  env:any;
  allowedCountryCodes:any[]=[];
  countries: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private tokenStorage: TokenStorageService,
    private userService: UserService,
    private router: Router,
    private modalService: MdbModalService,
    private session: SessionService,
  ) { }
  @ViewChild('myForm', { static: false }) myForm!: NgForm;

  submitForm() {
    if (this.myForm.valid) {
      // Submit the form data
      console.log(this.myForm.value);

    }
  }

  ngOnInit(): void {
    this.initializeInstitutionForm();
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.user = this.tokenStorage.getUser().username;
      this.role = this.user.role;
      this.env = this.tokenStorage.getUserEnv();
    }
    this.countryList();
    this.getCountryCode();
  }
  checkInstCode(instCode: any) {
    this.userService.validateInstCode(instCode).subscribe({
      next: (data) => {
        if (data.status == 'SUCCESS') {
          this.instForm.controls['institutionCode'].setErrors(null);
        } else if (data.reason == "Institution already exist") {
          this.instForm.controls['institutionCode'].setErrors({
            alreadyExist: true,
          });
        } else {
          this.instForm.controls['institutionCode'].setErrors({
            invalid: true,
          });
        }
      },
      error: (err) => {
        this.instForm.controls['institutionCode'].setErrors({ invalid: true });
      },
    });
  }

  onNewPasswordFocus() {
    this.showPasswordStrength = true;
  }

  onNewPasswordBlur() {
    this.showPasswordStrength = false;
  }

  toggleNewPasswordTextType() {
    this.newPasswordType = !this.newPasswordType;
  }

  initializeInstitutionForm(): void {
    this.instForm = this.formBuilder.group({
      institutionCode: ['', [Validators.required]],
      institutionName: ['', [Validators.required]],
      institutionAddress: ['', [Validators.required]],
      institutionContactNo: ['', [Validators.required]],
      contactNo: ['', [Validators.required]],
      institutionEmail: ['', [Validators.required, Validators.email]],
      FixApiEnableCheck: [''],
      AccountApiEnableCheck: [''],
      DwmEnableCheck: [''],
      DepositAutoEnableCheck: [''],
      WithdrawAutoEnableCheck: [''],
      bypassBuyingPower: [''],
      publicKey: ['', [Validators.required]],
      appKey: ['', [Validators.required]],
      appSecret: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(20)]],
    });
  }

  isFormDirty(): boolean {
    return this.instForm.dirty;

  }

  getCountryCode(){
    this.userService.getIp().subscribe((ip) => {
      this.userService.getCountryCode(ip).subscribe((code) => {
        const countryCode = JSON.parse(code).country_calling_code;
        this.instForm.controls['institutionContactNo'].setValue(countryCode+"-00000000");
        this.con = countryCode;
      });
    });
  }

  countryList() {
    this.initialLoading = true;
    this.userService.getCountryList().subscribe((data: any) => {
      this.countries = data.countryList.sort((a: any, b: any) =>
        a.countryName > b.countryName ? 1 : -1
      );

      this.allowedCountryCodes = this.countries.map(
        (c: any) => c.countryCode.toLowerCase()
      );

      this.initialLoading = false;
    });
  }

  generateAppKey() {
    const generatedAppKey = Math.random().toString(16).slice(2,8) +(new Date()).getTime() + Math.random().toString(16).slice(2,8);
    this.instForm.patchValue({
      appKey: generatedAppKey.replace(/.{5}(?!$)/g, '$&-')
    });
  }

  generateAppSecret(length=16, charset="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789") {
    const generatedAppSecret = new Array(length)
      .fill(null)
      .map(()=> charset.charAt(Math.floor(Math.random() * charset.length)))
      .join('');
    this.instForm.patchValue({
      appSecret: generatedAppSecret
    });

  }

  onClickAddInstitution(): any {
    this.session.clear();
    this.submitForm();
    this.addInstitutionSubmitted = true;
    if (this.instForm.invalid) {
      this.toastr.error('Please fill the form', 'Error');
      this.isFormValid = false;
      return false;
    }

    this.loading = true;
    const {
      institutionCode,
      institutionName,
      institutionAddress,
      institutionEmail,
      institutionContactNo,
      contactNo,
      FixApiEnableCheck,
      AccountApiEnableCheck,
      DwmEnableCheck,
      DepositAutoEnableCheck,
      WithdrawAutoEnableCheck,
      bypassBuyingPower,
      publicKey,
      appKey,
      appSecret
    } = this.instForm.value;

    const
      institutionStatus = 0,
      activationPeriod = 0,
      suspensionPeriod = 0,
      deletionPeriod = 0,
      openApiEnabled = 1;

    this.userService
      .createInstitution(
        institutionCode,
        institutionName,
        institutionAddress,
        institutionEmail,
        contactNo ? this.con + "-" + contactNo : '',
        this.user,
        institutionStatus,
        activationPeriod,
        suspensionPeriod,
        deletionPeriod,
        openApiEnabled,
        FixApiEnableCheck == true ? 1 : 0,
        AccountApiEnableCheck == true ? 1 : 0,
        DwmEnableCheck == true ? 1 : 0,
        DepositAutoEnableCheck == true ? 1 : 0,
        WithdrawAutoEnableCheck == true ? 1 : 0,
        bypassBuyingPower == true ? 1 : 0,
        publicKey,
        appKey,
        appSecret
      )
      .subscribe({
        next: (data) => {
          this.loading = false;
          if (data.status == 'SUCCESS') {
            this.isFormValid = true;
            this.readOnlyValue = true;
            this.instCode = data.institutionList[0].institutionCode;
            const list = { valid: this.isFormValid, instCode: this.instCode }
            this.session.setItem('newInstCode', this.instCode);
            this.session.setItem('institutionContactNo', contactNo);
            this.session.setItem('institutionAddress', institutionAddress);
            this.apiEvent.emit(list);
            this.btnClicked.emit();
            this.instForm.markAsPristine();
            this.toastr.success('Institution created successfully', 'Success');
            return true;
          } else {
            this.errorMessage = data.reason;
            this.isSignUpFailed = true;
            this.toastr.error(
              this.errorMessage,
              'Unable to create institution'
            );
            return false;
          }
        },
        error: (err) => {
          this.loading = false;
          this.errorMessage = err.error.message;
          this.isSignUpFailed = true;
          this.toastr.error(
            this.errorMessage,
            'Unable to create institution'
          );
          return false;
        },
      });

  }

  updateInstitution(): any {
    if (this.isFormDirty()) {
      this.instForm.markAsPristine();

      this.addInstitutionSubmitted = true;
      if (this.instForm.invalid) {
        this.toastr.error('Please fill the form', 'Error');
        this.isFormValid = false;
        return true;
      }

      this.isFormValid = true;
      this.loading = true;
      const {
        institutionName,
        institutionAddress,
        institutionEmail,
        institutionContactNo,
        FixApiEnableCheck,
        AccountApiEnableCheck,
        DepositAutoEnableCheck,
        WithdrawAutoEnableCheck,
        bypassBuyingPower,
        publicKey,
        appKey,
        appSecret
      } = this.instForm.value;

      const
        institutionStatus = 0,
        activationPeriod = 0,
        suspensionPeriod = 0,
        deletionPeriod = 0,
        openApiEnabled = 1;

      this.userService
        .updateInstitution(
          this.instCode,
          institutionName,
          institutionAddress,
          institutionEmail,
          institutionContactNo ? institutionContactNo.dialCode + "-" + institutionContactNo.number : '',
          this.user,
          institutionStatus,
          activationPeriod,
          suspensionPeriod,
          deletionPeriod,
          openApiEnabled,
          FixApiEnableCheck == true ? 1 : 0,
          AccountApiEnableCheck == true ? 1 : 0,
          DepositAutoEnableCheck == true ? 1 : 0,
          WithdrawAutoEnableCheck == true ? 1 : 0,
          bypassBuyingPower == true ? 1 : 0,
          publicKey,
          appKey,
          appSecret
        )
        .subscribe({
          next: (data) => {
            if (data.status == 'SUCCESS') {
              this.loading = false;
              this.btnClicked.emit();
              this.toastr.success('Institution updated successfully', 'Success');
            } else {
              this.loading = false;
              this.errorMessage = data.reason;
              this.toastr.error(
                this.errorMessage,
                'Unable to updated institution'
              );
            }
          },
          error: (err) => {
            this.loading = false;
            this.errorMessage = err.error.message;
            this.isSignUpFailed = true;
            this.toastr.error(
              this.errorMessage,
              'Unable to updated institution'
            );
          },
        });
    } else {
      this.btnClicked.emit();
    }
  }

  reloadPage(): void {
    window.location.reload();
  }

  get formInstControl(): { [key: string]: AbstractControl } {
    return this.instForm.controls;
  }

}
